import apiClient from "./client";
import type { GetDashboardParams, DashboardListResponse } from "../types/dashboard";

export const getDashboard = async (
  params: GetDashboardParams
): Promise<DashboardListResponse> => {
  const { data } = await apiClient.get<DashboardListResponse>("/dashboard", {
    params: {
      order: params.order,
      sort: params.sort,
      page: params.page,
      limit: params.limit,
    },
  });
  return data;
};
